import { render, staticRenderFns } from "./purchaseRequest.vue?vue&type=template&id=083adbdf&scoped=true&"
import script from "./purchaseRequest.vue?vue&type=script&lang=js&"
export * from "./purchaseRequest.vue?vue&type=script&lang=js&"
import style0 from "./purchaseRequest.vue?vue&type=style&index=0&id=083adbdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083adbdf",
  null
  
)

export default component.exports